export class EnaioLicenseModule {
    name: string;
    count = 0;
    type: string;
    additional: string;
}
